// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.start-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 90vh;
  color: #000;
}

.start-button h1 {
  margin-bottom: 20px;
  font-family: 'Orbitron', sans-serif;
}

.start-button button {
  border-radius: 30px;
  padding: 20px 40px;
  text-transform: uppercase;
  background-color: #009374;
  border: none;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out, color 0.2s ease-in-out;
}

/* Styles for mobile devices */
@media only screen and (max-width: 767px) {
  .start-button h1 {
    font-size: 3em;
    margin-bottom: 10px;
  }

  .start-button button {
    padding: 15px 30px;
    font-size: 1.2em;
  }
}

/* Styles for tablets and larger screens */
@media only screen and (min-width: 768px) {
  .start-button h1 {
    font-size: 85px;
    margin-bottom: 40px;
  }

  .start-button button {
    padding: 30px 50px;
    font-size: 45px;
  }
}

/* Styles for larger screens */
@media only screen and (min-width: 1024px) {
  .start-button h1 {
    font-size: 45px;
    margin-bottom: 20px;
  }

  .start-button button {
    padding: 20px 40px;
    font-size: 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Start.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kGAAkG;AACpG;;AAEA,8BAA8B;AAC9B;EACE;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA,0CAA0C;AAC1C;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":[".start-button {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 90vh;\n  color: #000;\n}\n\n.start-button h1 {\n  margin-bottom: 20px;\n  font-family: 'Orbitron', sans-serif;\n}\n\n.start-button button {\n  border-radius: 30px;\n  padding: 20px 40px;\n  text-transform: uppercase;\n  background-color: #009374;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out, color 0.2s ease-in-out;\n}\n\n/* Styles for mobile devices */\n@media only screen and (max-width: 767px) {\n  .start-button h1 {\n    font-size: 3em;\n    margin-bottom: 10px;\n  }\n\n  .start-button button {\n    padding: 15px 30px;\n    font-size: 1.2em;\n  }\n}\n\n/* Styles for tablets and larger screens */\n@media only screen and (min-width: 768px) {\n  .start-button h1 {\n    font-size: 85px;\n    margin-bottom: 40px;\n  }\n\n  .start-button button {\n    padding: 30px 50px;\n    font-size: 45px;\n  }\n}\n\n/* Styles for larger screens */\n@media only screen and (min-width: 1024px) {\n  .start-button h1 {\n    font-size: 45px;\n    margin-bottom: 20px;\n  }\n\n  .start-button button {\n    padding: 20px 40px;\n    font-size: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
